import type { AlertVariant } from '@/components/ui'

import type { UsageSummary } from './types'

type BannerKind = 'paused' | 'trialEnded' | 'pastDue' | 'openInvoice' | 'lowBalance' | 'trial'

interface BannerDecision {
  readonly kind: BannerKind
  readonly variant: AlertVariant
}

/**
 * Uma única faixa, prioridade decrescente (`04` §4.2). Em `Observe` nenhuma faixa: o estado é interno até a
 * cobrança valer. Exportado para teste.
 */
export function decideBanner(summary: UsageSummary): BannerDecision | null {
  if (summary.enforcement === 'Observe') {
    return null
  }
  if (summary.pausedForCredits) {
    return { kind: 'paused', variant: 'danger' }
  }
  if (summary.state === 'TrialEnded') {
    return { kind: 'trialEnded', variant: 'warning' }
  }
  if (summary.state === 'PastDue') {
    return { kind: 'pastDue', variant: 'warning' }
  }
  if (summary.state === 'Trial' && summary.openInvoice !== null) {
    return { kind: 'openInvoice', variant: 'info' }
  }
  if (summary.lowBalance) {
    return { kind: 'lowBalance', variant: 'info' }
  }
  if (summary.state === 'Trial') {
    return { kind: 'trial', variant: 'info' }
  }
  return null
}
